<template>
  <div>
    <DetailIndex :userBizContactFormCode="params.code" />
  </div>
</template>
<script>
import DetailIndex from './components/detail'
export default {
  components: { DetailIndex },
  name: 'opview-myBizContactForm',
  computed: {
    params() {
      return this.$route.params
    },
  },
}
</script>
